import './productReviews.scss';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CommentForm from './CommentForm';
import ProductSubTitle from '../ProductSubTitle';
import ReviewItem from './ReviewItem';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { LocalType } from '../../../models/localType';
import { ProductReviewsReview } from '../../../models/productReviewsModel';
import { Button } from '../../primitives';

const MAX_REVIEW = 4;

type ProductReviewsProps = {
    product: Queries.ProductJsonTemplateFragment;
    reviews?: ProductReviewsReview[];
    isProductReviewOpen: boolean;
    setProductReviewOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ProductReviews(props: ProductReviewsProps) {
  
    const { product, setProductReviewOpen, isProductReviewOpen, reviews } = props;

    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [comment, setComment] = useState('');
    const [hideOverflow, setHideOverflow] = useState<boolean>(true);
    const { currentLocale } = usePageLocalization() as keyof LocalType;
    const { t } = useTranslation('templatePages');
    
    const productCode: string = product.code ? product.code : '';
    const productTitle = product.title ? product.title[currentLocale] : '';
   
    return (
        <div className='product-reviews'>
            <ProductSubTitle textKey='reviews-title' />
            <div className='product-reviews-header'>
                <div className='review-text'>
                    {t('review-comment', {
                        title: productTitle,
                    })}
                </div>
                <div className='button-container'>
                    <Button
                        className='add-comment-btn century-hover-blue-button'
                        label={t('review-btn') as string}
                        onClick={() =>
                            setProductReviewOpen(!isProductReviewOpen)
                        }
                    />
                </div>
            </div>
            {(reviews && reviews.length > 0 || isProductReviewOpen) && (
                <div className='container reviews'>
                    {isProductReviewOpen && (
                        <CommentForm
                            name={name}
                            setName={setName}
                            title={title}
                            setTitle={setTitle}
                            comment={comment}
                            setComment={setComment}
                            sku={productCode}
                            slug={product.slug}
                            setWriteCommentOpen={setProductReviewOpen}
                        />
                    )}
                    {reviews!.map(
                        (review: ProductReviewsReview, index: number) => {
                            return (
                                <ReviewItem
                                    key={`product_review_${index}`}
                                    review={review}
                                    hidden={
                                        index > MAX_REVIEW && hideOverflow
                                            ? true
                                            : false
                                    }
                                />
                            );
                        }
                    )}
                    {reviews!.length > MAX_REVIEW && (
                        <div
                            className='review-more'
                            onClick={() => {
                                setHideOverflow(!hideOverflow);
                            }}
                        >
                            {hideOverflow ? t('read-more') : t('hide')}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
    
}